var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-element",class:{
    '_free-height': _vm.freeHeight,
    '_small': _vm.small,
  },style:(_vm.styles)},[_c('div',{staticClass:"-over-the-box"},[_c('div',{staticClass:"--label"},[_vm._t("label")],2),_c('div',{staticClass:"--warning"},[_vm._t("warning")],2)]),_c('div',{staticClass:"-box",class:{
      '_borderless': _vm.borderless,
    }},[_c('div',{staticClass:"--input"},[_vm._t("default")],2),(_vm.hasControllerSlot)?_c('div',{staticClass:"--controller"},[_vm._t("controller")],2):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }